import { useRef } from 'react';

let globalIdCounter = 0; // A simple global counter for unique IDs

const generateUniqueId = () => {
    globalIdCounter++;

    return `react-id-${globalIdCounter}`;
};

/**
 * Polyfill for React.useId()
 * Replace with React.useId() when upgraded to react 18+
 */
export function useIdPolyfill() {
    const idRef = useRef(null);

    if (idRef.current === null) {
        idRef.current = generateUniqueId();
    }

    return idRef.current;
}
